import React from 'react';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import PartnersData from 'utils/corporateSettings.json';
import 'moment/locale/pt-br';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
import { Container, Div, Title, Subtitle, Icon, IconMobile } from './styles';
import { useHistory } from 'react-router-dom';
import { formatCPF, formatPhone } from 'react-data-formatter';

function UserList({ users }) {
  const history = useHistory();

  const navigate = async (e) => {
    e.preventDefault();
    history.push(`/backoffice/detalhes-do-usuario/${users.id}`);
  };

  const partnerInfo = PartnersData[PartnersData.findIndex((i) => i.id_partner === users?.partner?.id)];

  return (
    <>
      <Container onClick={navigate}>
        <div className="description">
          <div className="iconProposal">
            <Tooltip title={`Parceiro ${partnerInfo?.name}`}>
              <img className="partnerIcon" src={partnerInfo?.logos?.small} alt={partnerInfo?.name} />
            </Tooltip>
          </div>
          {/* <div className="iconProfile">
            <Avatar
              src={users?.picture}
              alt={users?.name}
              sx={{ width: 35, height: 35 }}
              style={{ marginRight: 9, cursor: 'pointer' }}
            />
          </div> */}

          <Div style={{ width: '40%' }}>
            <Title>{users?.name}</Title>
            <Subtitle>{formatCPF(users?.cpf)}</Subtitle>
          </Div>

          <Div style={{ width: '50%' }}>
            <Subtitle>{formatPhone(users?.phone)}</Subtitle>
            <Subtitle>{users?.email}</Subtitle>
          </Div>

          <Div>
            <Title>Tipo de usuário:</Title>
            <Subtitle>{users?.isBroker || users?.isBackoffice ? 'Colaborador' : 'Cliente'}</Subtitle>
          </Div>

          <Icon>
            <HiOutlineArrowNarrowRight color="#C4C4C4" size={25} className="iconArrow" />
          </Icon>

          <IconMobile>
            <Avatar
              src={users?.picture}
              alt={users?.name}
              sx={{ width: 50, height: 50 }}
              style={{ marginRight: 9, cursor: 'pointer' }}
            />
          </IconMobile>
        </div>
      </Container>
    </>
  );
}

export default UserList;
